import type { ReactNode } from 'react';

import clsx from 'clsx';

import { Flex } from '@/components/common/Flex';
import { Text } from '@/components/common/Text';
import { type WithClassName } from '@/types/react';

import styles from './Tabs.module.scss';

export type Tab<TabKey extends string> = {
  key: TabKey;
  title: ReactNode;
};

type TabsProps<TabKey extends string> = WithClassName & {
  tabs: Tab<TabKey>[];
  selectedTabKey: TabKey | null;
  setSelectedTabKey: (tabKey: TabKey) => unknown;
};

export const Tabs = <TabKey extends string>(props: TabsProps<TabKey>) => {
  const { className, tabs, selectedTabKey, setSelectedTabKey } = props;

  return (
    <Flex className={clsx(styles.root, className)} childMinSize="unset">
      {tabs.map((tab) => (
        <Flex
          key={tab.key}
          className={clsx(styles.tab, {
            [styles.isActive]: tab.key === selectedTabKey,
          })}
          onClick={() => setSelectedTabKey(tab.key)}
        >
          <Text type="medium16" whiteSpace="nowrap">
            {tab.title}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
};
